import './accordion.scss';

import classNames from 'classnames';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import React, { useEffect, useState } from 'react';

import { PortableText } from '../portableText';

export function Accordion({
	accordionItems,
	eyebrow,
	header,
	staticImage,
	verticalPadding,
}) {
	// state
	const [selectedItem, setSelectedItem] = useState(0);
	const [imageData, setImageData] = useState(accordionItems?.[0].image);
	const [gatsbyImageData, setGatsbyImageData] = useState(null);

	// module padding
	const modulePaddingTop = verticalPadding?.modulePaddingTop;
	const modulePaddingBottom = verticalPadding?.modulePaddingBottom;

	const clickHandler = (id) => {
		setSelectedItem(id);

		if (!staticImage) {
			setImageData(accordionItems[id]?.image);
		}
	};

	const keyHandler = (e, id) => {
		if (e.key === 'Enter') {
			clickHandler(id);
		}
	};

	useEffect(() => {
		if (imageData) {
			setGatsbyImageData(getImage(imageData.asset));
		}
	}, [imageData]);

	return (
		<div
			className={classNames(
				'accordionContainer',
				'module-padding-h',
				modulePaddingBottom,
				modulePaddingTop
			)}
		>
			<div className='accordionContainerInner'>
				<div className='accordion-breakdown'>
					<div className='accordion-title'>
						{eyebrow && (
							<h2 className='heading-xs accordionEyebrowText'>
								{eyebrow}
							</h2>
						)}
						{eyebrow && header && (
							<h3 className='heading-xl'>{header}</h3>
						)}
						{!eyebrow && header && (
							<h2 className='heading-xl'>{header}</h2>
						)}
					</div>
					<ul className='accordion-container'>
						{accordionItems?.map((accordionItem, id) => {
							const _key = accordionItem._key;
							const icon = accordionItem.icon;
							const iconSVG = accordionItem.iconSvg;

							return (
								<li
									className={classNames(
										'accordion-block f fdc',
										selectedItem === id && 'selected'
									)}
									id={id}
									onClick={() => clickHandler(id)}
									onKeyDown={(event) => keyHandler(event, id)}
									tabIndex={0}
									key={_key}
								>
									<div className='accordion-header-container f'>
										<div className='accordion-icon f jcc pr1'>
											{iconSVG ? (
												<span
													dangerouslySetInnerHTML={{
														__html: iconSVG,
													}}
												/>
											) : icon?.asset ? (
												<GatsbyImage
													alt='accordion image'
													image={getImage(icon.asset)}
												/>
											) : null}
										</div>
										{accordionItem.title && (
											<h4 className='heading-s'>
												{accordionItem.title}
											</h4>
										)}
									</div>
									{accordionItem?._rawDescription && (
										<div className='accordion-copy'>
											<PortableText
												blocks={
													accordionItem._rawDescription
												}
											/>
										</div>
									)}
								</li>
							);
						})}
					</ul>
				</div>
				{gatsbyImageData && (
					<div className='accordionImageContainer'>
						<GatsbyImage
							alt={imageData?.alt || ''}
							image={gatsbyImageData}
							loading='eager'
						/>
					</div>
				)}
				{!gatsbyImageData && (
					<div className='accordionImageContainer'>
						<img
							alt={imageData?.alt || ''}
							src={imageData?.asset?.url || ''}
						/>
					</div>
				)}
			</div>
		</div>
	);
}
